import type { UnknownAction } from '@reduxjs/toolkit';

export const sentryReduxOptions = {
  attachReduxState: false,
  actionTransformer: (action: UnknownAction): UnknownAction => ({ type: action.type }),
  stateTransformer: (): null => null,
};
